<template>
  <div class="popup-form">

    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Fixácia</div>
        <button
          class="w-button saveformBtn"
          form="maturity-choose"
          type="submit"
        >
          Nastaviť
        </button>
      </div>

      <form @submit.prevent="saveApplicationData" id="maturity-choose">
        <div class="input-group">
          <label for="najomne" class="field-label">Splatnosť v rokoch</label>
          <input
            v-model="splatnost_r"
            type="number"
            step="1"
            min="0"
            max="40"
            class="text-input w-input required"
            maxlength="256"
            name="najomne"
            data-name="najomne"
            placeholder=""
            id="najomne"
            required=""
          />
        </div>
      </form>

    </div>
  </div>
</template>

<script>
export default {
  name: "MaturityChoosePopUp",
  props: {
    payload: Object
  },
  methods: {
    saveApplicationData() {
      this.$store.dispatch("mortgageDetailState/fetchOffer", {...this.payload, offerMeta: {...this.payload.offerMeta, splatnost_m: this.splatnost_r * 12}});
      this.closePopup();
    },
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data() {
    return {
      splatnost_r: this.payload.offerMeta.splatnost_m / 12,
    }
  },
}
</script>

<style scoped>

</style>